module.exports = __webpack_public_path__ + "static/img/cabinet24_11.38d1149f.gif";